import React from 'react';

import './App.css';
import RootRouter from './navigation/root.router';

const App: React.FC = () => <RootRouter />;

export default App;
